import React, { useMemo } from 'react';
import VideoBlock from "../VideoBlock";
import ContactForm from "../ContactForm";
import CarouselTitle from "../CarouselTitle/CarouselTitle";
import { PortableText } from '@portabletext/react';
import HorizontalLine from '../HorizontalLine';
import Image from "next/image";
import { urlForImage } from '~/lib/sanity.image';
import GalleryItem from "../Gallery/GalleryItem";
import { makeid } from "~/helpers/common.helpers";
import SliderMulti from '../Sliders/SliderMulti';

const ContentTypeSimple = ({ title, body }) => (
  <div >
    <div className="text-left">
      <h2 className="text-3xl font-semibold text-primary mb-10">{title}</h2>
    </div>
    <div className='contentBlock text-left text-lg'>
      <PortableText value={body} />
    </div>
    <div className='my-4 lg:my-16'>
                <HorizontalLine />
            </div>
  </div>
);

const ContentTypeSimpleRight = ({ title, body }) => (
    <div>
        <div className="text-right">
            <h2 className="text-3xl font-semibold text-primary mb-10">{title}</h2>
        </div>
        <div className='contentBlock text-right text-lg'>
            <PortableText value={body} />
        </div>
        <div className='my-4 lg:my-16'>
                <HorizontalLine />
            </div>
    </div>
);

const ImageGrid = ({ title, logo, images = [] }) => {
    const slides = useMemo(() => 
        images?.map(image => ({
          _id: image._key,
          image,
          title: image.title
        })) || [],
        [images]
      );

    console.log(images);

    if (!images) {
      images = [] // if not images list intial 
    }

    return (
        <div>
            <div className='grid grid-cols-2 gap-0'>
                <div className='text-left'>
                {logo && (
                    <Image
                    src={urlForImage(logo).url()}
                    alt={title ? title : "logo"}
                    width={0}
                    height={0}
                    sizes="100vw"
                    style={{ width: '144px', height: 'auto' }}
                    className="h-full w-full object-cover" />
                )}
                </div>
                <div className="text-right">
                    <h2 className="text-3xl lg:text-5xl font-semibold text-primary mb-10">{title}</h2>
                </div>
            </div>
            <div className='py-10 hidden lg:block'>
                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
                    {images.length ? (
                        images.map((item) => <GalleryItem key={item._id + makeid(5)} id={item._key} title={item.title} href={null} image={item} fill={!item.fill ? false : true} />)
                        ) : (
                        <></>
                    )}
                </div>
            </div>
            <div className='py-10 block lg:hidden'>
                <SliderMulti items={slides} imageOnly={true} />
            </div>
            <div className='my-4 lg:my-16'>
                <HorizontalLine />
            </div>
        </div>
    )
}

const ContentTypeTwoImages = ({ title, imageOne, imageTwo, body }) => (    
    <>
    <div className='grid grid-cols-1 lg:grid-cols-2 gap-10'>
        <div className='grid grid-cols-2 gap-4'>
            {imageOne && (
                <Image
                src={urlForImage(imageOne).url()}
                alt={title ? title : "imageOne"}
                width={0}
                height={0}
                sizes="100vw"
                style={{ width: '100%', height: 'auto' }}
                className="h-full w-full object-cover" />
            )}
            {imageTwo && (
                <Image
                src={urlForImage(imageTwo).url()}
                alt={title ? title : "imageTwo"}
                width={0}
                height={0}
                sizes="100vw"
                style={{ width: '100%', height: 'auto' }}
                className="h-full w-full object-cover" />
            )}
        </div>
        <div>
            <div className="text-right">
                <h2 className="text-3xl font-semibold text-primary mb-10">{title}</h2>
            </div>
            <div className='contentBlock text-right text-lg'>
                <PortableText value={body} />
            </div>
        </div>
    </div>
    <div className='my-4 lg:my-16'>
        <HorizontalLine />
    </div>
  </>
);

const ContentTypeOneImages = ({ title, imageOne, body }) => (    
  <>
  <div className='grid grid-cols-1 lg:grid-cols-2 gap-10'>
      <div>
          {imageOne && (
              <Image
              src={urlForImage(imageOne).url()}
              alt={title ? title : "imageOne"}
              width={0}
              height={0}
              sizes="100vw"
              style={{ width: '100%', height: 'auto' }}
              className="h-full w-full object-cover" />
          )}          
      </div>
      <div>
          <div className="text-right">
              <h2 className="text-3xl font-semibold text-primary mb-10">{title}</h2>
          </div>
          <div className='contentBlock text-right text-lg'>
              <PortableText value={body} />
          </div>
      </div>
  </div>
  <div className='my-4 lg:my-16'>
      <HorizontalLine />
  </div>
</>
);

const FileDownloadLink = ({ file }) => (
  <div className="relative h-full w-full">
    <a 
      href={file.fileURL}
      className="border-black flex p-4 download-bg border cursor-pointer"
      target="_blank"
      rel="noopener noreferrer"
    >
      {file.title}
    </a>
  </div>
);

const CarouselBlock = ({ imageCarousel }) => {
  const slides = useMemo(() => 
    imageCarousel?.map(image => ({
      _id: image._key,
      image,
      title: image.title
    })) || [],
    [imageCarousel]
  );
  
  return (
    <div className='mb-4 lg:mb-16'>
      <CarouselTitle slides={slides} />      
    </div>
  );
};

const TripleCarouselBlock = ({ title, body, logo, imageCarousel }) => {
    const slides = useMemo(() => 
      imageCarousel?.map(image => ({
        _id: image._key,
        image,
        title: image.title
      })) || [],
      [imageCarousel]
    );
    
    return (
        <div>
            <div className='grid grid-cols-2 gap-0'>
                <div className='text-left'>
                {logo && (
                    <Image
                    src={urlForImage(logo).url()}
                    alt={title ? title : "logo"}
                    width={0}
                    height={0}
                    sizes="100vw"
                    style={{ width: '144px', height: 'auto' }}
                    className="h-full w-full object-cover" />
                )}
                </div>
                <div className="text-right">
                    <h2 className="text-3xl lg:text-5xl font-semibold text-primary mb-10">{title}</h2>
                </div>
            </div>
            <div className='py-10'>
                <SliderMulti items={slides} imageOnly={true} />
            </div>
            <div className='contentBlock text-right text-lg'>
                <PortableText value={body} />
            </div>
            <div className='my-4 lg:my-16'>
                <HorizontalLine />
            </div>
        </div>      
    );
  };

const FileCollectionBlock = ({ title, body, fileCollection, previewImage, layout = 'layout1' }) => (
  layout === 'layout1' ? (  
  <div>
    <div className="text-left">
      <h2 className="text-3xl font-semibold text-primary mb-10">{title}</h2>
    </div>
    <div className='contentBlock text-left text-lg'>
      <PortableText value={body} />
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-10">
      {fileCollection?.map((file) => (
        <FileDownloadLink key={file._key} file={file} />
      ))}
    </div>
    <div className='text-left my-10 relative'>
        {previewImage && (
            // eslint-disable-next-line @next/next/no-img-element
            <img
            src={urlForImage(previewImage).url()}
            alt={title ? title : "previewImage"}
            />
        )}
    </div>
    <div className='my-4 lg:my-16'>
        <HorizontalLine />
    </div>
  </div>
  ) : (
    <div>
      <div className="text-left">
        <h2 className="text-3xl font-semibold text-primary mb-10">{title}</h2>
      </div>
      <div className='text-left my-10 relative'>
          {previewImage && (
              // eslint-disable-next-line @next/next/no-img-element
              <img
              src={urlForImage(previewImage).url()}
              alt={title ? title : "previewImage"}
              />
          )}
      </div>
      <div className='contentBlock text-left text-lg'>
        <PortableText value={body} />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-10">
        {fileCollection?.map((file) => (
          <FileDownloadLink key={file._key} file={file} />
        ))}
      </div>      
      <div className='my-4 lg:my-16'>
          <HorizontalLine />
      </div>
    </div>
  )
);

const ModuleList = ({ moduleList }) => {
  const moduleComponents = {
    videoBlock: (item) => (
      <div className='mx-10 mb-10'>
        <VideoBlock videos={item.videoFiles} />
      </div>
    ),

    contactBlock: (item) => (
      <div>
        <ContactForm title={item.title} />
      </div>
    ),
    
    contentBlock: (item) => {
      const contentTypes = {
        simple: () => <ContentTypeSimple title={item.title} body={item.body} />,
        simpleRight: () => <ContentTypeSimpleRight title={item.title} body={item.body} />,
        twoImages: () => <ContentTypeTwoImages title={item.title} imageOne={item.imageOne} imageTwo={item.imageTwo} body={item.body} />,
        oneImage: () => <ContentTypeOneImages title={item.title} imageOne={item.imageOne} body={item.body} />
      };
      return contentTypes[item.contentType]?.() || null;
    },
    fileCollectionBlock: (item) => (
      <FileCollectionBlock 
        title={item.title}
        body={item.body}
        fileCollection={item.fileCollection}
        previewImage={item.previewImage}
        layout={item.layout}
      />
    ),
    
    carouselBlock: (item) => {
        const contentTypes = {
            single: () => <CarouselBlock imageCarousel={item.imageCarousel} />,
            triple: () => <TripleCarouselBlock title={item.title} body={item.body} logo={item.logo} imageCarousel={item.imageCarousel} />,
        }
        return contentTypes[item.contentType]?.() || null;
    },

    imageGridBlock: (item) => <ImageGrid title={item.title} logo={item.logo} images={item.imageGrid} />
  };

  const renderModule = (item) => {
    const Component = moduleComponents[item._type];
    return Component ? Component(item) : <div>default</div>;
  };

  if (!moduleList?.length) return null;

  return (
    <div>
      {moduleList.map((item) => (
        <div key={item._id}>
          {renderModule(item)}
        </div>
      ))}
    </div>
  );
};

export default React.memo(ModuleList);